import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useRef, useMemo } from 'react';
import useInViewport from '../../hooks/useInViewport';

var Lazyload = function Lazyload(props) {
  var ref = useRef(null);

  var _useInViewport = useInViewport(ref),
      inViewPort = _useInViewport[0];

  var initedRef = useRef(false);
  var height = props.height,
      placeholder = props.placeholder,
      children = props.children,
      className = props.className,
      style = props.style;
  var isInit = useMemo(function () {
    if (inViewPort && !initedRef.current) {
      initedRef.current = true;
    }

    return initedRef.current;
  }, [inViewPort]);
  return isInit ? _jsx(_Fragment, {
    children: children
  }) : _jsx("div", Object.assign({
    ref: ref,
    className: className,
    style: Object.assign({
      height: height
    }, style)
  }, {
    children: placeholder
  }));
};

Lazyload.displayName = 'Lazyload';
export default Lazyload;